import { render, staticRenderFns } from "./builder-download-data-button.vue?vue&type=template&id=e6666e70&"
import script from "./builder-download-data-button.vue?vue&type=script&lang=js&"
export * from "./builder-download-data-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports